import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Body, SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import Container from '@grnhse/seedling/lib/birch/components/container';
import styled from 'styled-components';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import { withLocalePrefix } from 'shared/utils/translation';
import { CalibrationSettings, Skill } from 'talent_matching/types';
import SuggestedSkills from '../suggested_skills';
import AddSkillField from '../add_skill_field';

const t = withLocalePrefix('talent_matching.modals.calibration');

const SkillsContainer = styled(Container)`
  background-color: ${FullPalette.WHITE};
  border-color: ${FullPalette.GREY_600};
  box-shadow: none;
`;

type Props = {
  disabled: boolean;
  calibration?: CalibrationSettings;
  renderSkills: (
    disabled?: boolean,
    skillsOverride?: Skill[]
  ) => React.ReactNode;
  suggestedSkillsError?: string;
};

const CalibrationSkillsPanel = ({
  disabled: isDisabled,
  calibration,
  renderSkills,
  suggestedSkillsError,
}: Props) => {
  const overrideSkills = (calibration?.skills as Skill[]) || undefined;

  return (
    <SkillsContainer>
      <Stack spacing={2}>
        <Stack spacing={0.25}>
          <Body medium>{t('phase2.calibrate_skills.title')}</Body>
          {!isDisabled && (
            <SecondaryBody>
              {t('phase2.calibrate_skills.description')}
            </SecondaryBody>
          )}
        </Stack>
        {renderSkills(isDisabled, overrideSkills)}
        {!isDisabled && (
          <>
            <SuggestedSkills errorMessage={suggestedSkillsError || undefined} />
            <AddSkillField />
          </>
        )}
      </Stack>
    </SkillsContainer>
  );
};

export default CalibrationSkillsPanel;
